export const NOW_PLAYING = 'now_playing'
export const POPULAR = 'popular'
export const TOP_RATED = 'top_rated'
export const UPCOMING = 'upcoming'
